import { Sidebar } from 'common/components/sidebar/Sidebar.tsx'
import { menuTabs } from '@/components/sidebar/sidebarTabsAdvertiser.tsx'

export const SidebarAdvertiser = (props: any) => <Sidebar {...props} mode={props.mode} menuTabs={menuTabs}/>